import * as marietta from '../..';
import { ITEM_MODE_NO, SITE_COLOR, SITE_INPUT_MODE } from '../Constants';

class WebcadXMLExporter {
    /**
     * 保存データの作成
     */
    static retXML: Document;

    static firstNode: Element;

    static planNode: Element;

    static createWebCADData(): XMLDocument {
      const xmlText: string = '<webcad></webcad>';
      const parser: DOMParser = new DOMParser();
      this.retXML = parser.parseFromString(xmlText, 'text/xml');
      this.firstNode = this.retXML.querySelector('webcad');

      // アプリケーション
      const appNode: Element = this.appicationXML();
      this.firstNode.appendChild(appNode);

      // プラン情報
      this.planNode = this.planInfoXML();
      this.firstNode.appendChild(this.planNode);

      // 3D用パラメータ（）
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam) {
        const modelParamNode: Element = this.modelParamInfoXML();
        this.planNode.appendChild(modelParamNode);
      }

      // 敷地
      const siteNode: Element = this.siteInfoXML();
      this.planNode.appendChild(siteNode);

      // 間取
      const roomNode: Element = this.roomInfoXML();
      this.planNode.appendChild(roomNode);

      // 階段
      const stairNode: Element = this.stairInfoXML();
      this.planNode.appendChild(stairNode);

      // 建具
      const fitNode: Element = this.typeInfoXML('fitting', ITEM_MODE_NO.MODE_FITTING_NO);
      this.planNode.appendChild(fitNode);

      // 住設
      const equNode: Element = this.typeInfoXML('equipment', ITEM_MODE_NO.MODE_EQUIPMENT_NO);
      this.planNode.appendChild(equNode);

      // 家具
      const furNode: Element = this.typeInfoXML('furniture', ITEM_MODE_NO.MODE_FURNITURE_NO);
      this.planNode.appendChild(furNode);

      // エクステリア
      const extNode: Element = this.typeInfoXML('exterior', ITEM_MODE_NO.MODE_EXTERIOR_NO);
      this.planNode.appendChild(extNode);

      // 屋根
      const rofNode: Element = this.roofInfoXML();
      this.planNode.appendChild(rofNode);

      // WebCADノード
      // retXML.appendChild( firstNode );
      // retXML.ignoreWhite = true;
      // retXML.docTypeDecl = '<?xml version="1.0" encoding="utf-8" ?>';

      console.log(this.retXML);
      console.log(this.firstNode);

      return this.retXML;
    }

    /**
     * アプリ情報XML
     */
    static appicationXML(): Element {
      const appXML: Element = document.createElementNS(null, 'application');

      // アプリ名
      const childName: Element = document.createElementNS(null, 'name');
      childName.textContent = marietta.webcad.WebCADGlobal.APP_NAME;
      appXML.appendChild(childName);

      // バージョン
      const childVersion: Element = document.createElementNS(null, 'version');
      childVersion.textContent = marietta.webcad.WebCADGlobal.APP_VERSION;
      appXML.appendChild(childVersion);

      // バージョン
      const childCustomize: Element = document.createElementNS(null, 'customize');
      childCustomize.textContent = marietta.webcad.WebCADGlobal.APP_CUSTOM;
      appXML.appendChild(childCustomize);

      return appXML;
    }

    /**
     * プラン情報XML
     */
    static planInfoXML(): Element {
      const planNode: Element = document.createElementNS(null, 'plan');
      planNode.setAttribute('module', marietta.webcad.WebCADGlobal.webcad2Dmanager.modulePitch.toString());
      try {
        planNode.setAttribute('grid', marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnit.toString());
      } catch (e) {
        planNode.setAttribute('grid', '0.5');
      }
      planNode.setAttribute('building_type', marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType.toString());
      // 寸法補正（0: フリー寸法 / 1: モジュール補正）※アプリJSONの dimension_correction と同じ表現
      planNode.setAttribute('dimension_correction', marietta.webcad.WebCADGlobal.moduleManager.dimensionCorrection.toString());

      // 2017.04.14不要データ削除
      // planNode.setAttribute('area', '0');

      /* 2017.04.14不要データ削除
        //プラン名
        var planName = document.createElementNS(null, 'name');
        //TODO: usernameを追加
        //planName.innerText = marietta.webcad.WebCADGlobal.(username);
        planNode.appendChild(planName);
        */

      return planNode;
    }

    /**
     * 3D用パラメータXML
     */
    static modelParamInfoXML(): Element {
      const param: marietta.webcad.collection.ModelParamCollection = marietta.webcad.WebCADGlobal.webcad2Dmanager.modelParam;

      const baseNode: Element = document.createElementNS(null, 'model_param');

      if (param.option) baseNode.appendChild(param.option);
      if (param.height) baseNode.appendChild(param.height);
      if (param.auto) baseNode.appendChild(param.auto);
      if (param.material) baseNode.appendChild(param.material);
      return baseNode;
    }

    /**
     * 敷地情報XML
     */
    static siteInfoXML(): Element {
      const tarLayer: marietta.webcad.layer.SiteLayer = marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(1, ITEM_MODE_NO.MODE_SITE_NO);
      const itemList: any[] = tarLayer.getAllChildren();
      let tarItem: marietta.webcad.item.Site;
      let itemNode: Element;

      // 敷地一覧
      const siteNode: Element = document.createElementNS(null, 'site');
      siteNode.setAttribute('mode', tarLayer.mode.toString());
      // 敷地面積
      siteNode.setAttribute('area', String(tarLayer.getAreaAll()));
      // 方位
      siteNode.setAttribute('direction', String(marietta.webcad.WebCADGlobal.siteCompass.rotation));

      for (let i = 0, len = itemList.length; i < len; i += 1) {
        // TODO: js用に書き直し
        // eslint-disable-next-line no-continue
        if (!((itemList[i] as any) instanceof marietta.webcad.item.Site)) continue;
        tarItem = itemList[i];

        // アイテム
        itemNode = document.createElementNS(null, 'shape');
        itemNode.setAttribute('index', String(i + 1));
        itemNode.setAttribute('guid', String(tarItem.itemInfo.guid));
        itemNode.setAttribute('color', String((SITE_COLOR)));
        if (tarLayer.mode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE) {
          itemNode.setAttribute('base', String(tarItem.itemInfo.baseNo));
        }
        const pointXML = tarItem.getPointXML();
        for (let j = 0, len2 = pointXML.length; j < len2; j += 1) {
          itemNode.appendChild(pointXML[j]);
        }
        siteNode.appendChild(itemNode);
      }
      return siteNode;
    }

    /**
     * 部屋情報ノード
     */
    static roomInfoXML(list: any[] = null): Element {
      let tarItem: marietta.webcad.item.Room;
      let info: marietta.webcad.collection.ItemInfoCollection;
      let itemList: any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN1_NO);
      itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOMDOWN2_NO));
      itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOM_NO));
      if (list != null) {
        itemList = list;
      }

      // 部屋一覧
      let textSavePoint: marietta.core.Point;
      const roomNode: Element = document.createElementNS(null, 'room');
      for (let i = 0, len = itemList.length; i < len; i += 1) {
        tarItem = itemList[i];
        info = tarItem.itemInfo;
        // アイテム
        const itemNode: Element = document.createElementNS(null, 'item');
        // itemNode.setAttribute('koshi', '0');      2017.04.14不要データ削除
        itemNode.setAttribute('design_color', String(info.designColor ? marietta.webcad.util.WebCADUtil.convertNum16To10(info.designColor) : ''));
        itemNode.setAttribute('design_type', info.design_type ? info.design_type : '');
        itemNode.setAttribute('id', info.id);
        itemNode.setAttribute('index', (i + 1).toString());
        itemNode.setAttribute('guid', String(tarItem.itemInfo.guid));
        itemNode.setAttribute('color', String(marietta.webcad.util.WebCADUtil.convertNum16To10(info.color)));
        itemNode.setAttribute('f', info.floor.toString());

        // テキスト
        const textInfo: marietta.webcad.item.parts.RoomText = itemList[i].overlayText;
        const textNode = document.createElementNS(null, 'text');
        // textNode.setAttribute('x', textInfo.x.toString());
        // textNode.setAttribute('y', textInfo.y.toString());
        textSavePoint = itemList[i].overlayText.getSavePoint();

        textNode.setAttribute('x', textSavePoint.x.toString());
        textNode.setAttribute('y', textSavePoint.y.toString());
        textNode.setAttribute('area_visible', String(Number(textInfo.areaVisible)));
        textNode.setAttribute('auto_layout', String(Number(textInfo.autoLayout)));
        textNode.setAttribute('area_use_jyou', String(Number(textInfo.useJyou)));
        textNode.setAttribute('visible', String(Number(textInfo.visible)));
        textNode.textContent = textInfo.message;

        // シェイプ
        const shapeNode: Element = document.createElementNS(null, 'shape');
        const pointXML = tarItem.getPointXML();
        for (let j = 0, len2 = pointXML.length; j < len2; j += 1) {
          shapeNode.appendChild(pointXML[j]);
        }
        itemNode.appendChild(textNode);
        itemNode.appendChild(shapeNode);
        roomNode.appendChild(itemNode);
      }

      return roomNode;
    }

    /**
     * 階段ノード
     */
    static stairInfoXML(): Element {
      const itemList: any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_STAIR_NO);
      // XML
      const typeNode: Element = document.createElementNS(null, 'stair');
      for (let i = 0, len = itemList.length; i < len; i += 1) {
        const tarItem: marietta.webcad.item.Stair = itemList[i];
        const itemNode = document.createElementNS(null, 'item');
        itemNode.setAttribute('width', String(Math.abs(tarItem.itemInfo.width)));
        itemNode.setAttribute('depth', String(Math.abs(tarItem.itemInfo.height)));
        itemNode.setAttribute('x', String(tarItem.itemInfo.x));
        itemNode.setAttribute('y', String(-(tarItem.itemInfo.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
        itemNode.setAttribute('id', tarItem.itemInfo.id);
        itemNode.setAttribute('index', String(i + 1));
        itemNode.setAttribute('guid', String(tarItem.itemInfo.guid));
        itemNode.setAttribute('f', String(tarItem.itemInfo.floor));
        itemNode.setAttribute('rotation', String((tarItem.itemInfo.rotation < 0) ? tarItem.itemInfo.rotation + 360 : tarItem.itemInfo.rotation));
        itemNode.setAttribute('lr', String(Number(tarItem.itemInfo.lr)));
        itemNode.setAttribute('idthreed', String(tarItem.itemInfo.idthreed));

        // シェイプ
        const shapeNode: Element = document.createElementNS(null, 'shape');
        const pointXML = tarItem.getPointXML();
        for (let j = 0, len2 = pointXML.length; j < len2; j += 1) {
          shapeNode.appendChild(pointXML[j]);
        }
        itemNode.appendChild(shapeNode);
        typeNode.appendChild(itemNode);
      }

      return typeNode;
    }

    /**
     * 各種情報ノード
     */
    static typeInfoXML(typeName: string, typeNo: number): Element {
      let itemList: any[];
      if (typeName === 'fitting') {
        itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_FITTINGDOWN1_NO);
        itemList = itemList.concat(marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(typeNo));
      } else {
        itemList = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(typeNo);
      }

      // XML
      const typeNode: Element = document.createElementNS(null, typeName);
      for (let i = 0, len = itemList.length; i < len; i += 1) {
        const tarItem: marietta.webcad.item.MonicaObject = itemList[i];
        const itemNode: Element = document.createElementNS(null, 'item');
        // 建具は高さ情報・取り付け高さ
        if (typeName === 'fitting') {
          itemNode.setAttribute('width', String(Math.abs((tarItem as marietta.webcad.item.Fitting).itemInfo.width)));
          itemNode.setAttribute('width_mm', String(Math.abs((tarItem as marietta.webcad.item.Fitting).itemInfo.widthmm)));
          if ((tarItem as marietta.webcad.item.Fitting).itemInfo.use_mm) {
            itemNode.setAttribute('use_mm', String(Number((tarItem as marietta.webcad.item.Fitting).itemInfo.use_mm)));
          }

          // CAD APIのための情報
          itemNode.setAttribute('auto_height', String(Number((tarItem as marietta.webcad.item.Fitting).itemInfo.auto_height)));
          itemNode.setAttribute('z', String(Math.abs((tarItem as marietta.webcad.item.Fitting).itemInfo.z)));
          itemNode.setAttribute('height', String(Math.abs((tarItem as marietta.webcad.item.Fitting).itemInfo.fitting_height)));
          itemNode.setAttribute('window_frame', String(0));
          itemNode.setAttribute('type', '');
        } else {
          itemNode.setAttribute('depth', String(Math.abs((tarItem as marietta.webcad.item.MonicaObject).itemInfo.heightmm)));
          itemNode.setAttribute('width', String(Math.abs((tarItem as marietta.webcad.item.MonicaObject).itemInfo.widthmm)));
        }

        itemNode.setAttribute('x', String(tarItem.itemInfo.x));
        itemNode.setAttribute('y', String(-(tarItem.itemInfo.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H)));
        itemNode.setAttribute('id', tarItem.itemInfo.id);
        itemNode.setAttribute('index', String(i + 1));
        itemNode.setAttribute('guid', String(tarItem.itemInfo.guid));
        itemNode.setAttribute('f', String(tarItem.itemInfo.floor));
        itemNode.setAttribute('rotation', String((tarItem.itemInfo.rotation < 0) ? tarItem.itemInfo.rotation + 360 : tarItem.itemInfo.rotation));

        // TODO: アイテムの反転ロジックができたら整理して実装
        itemNode.setAttribute('lr', String(Number(tarItem.itemInfo.lr)));

        itemNode.setAttribute('idthreed', String(tarItem.itemInfo.idthreed));

        typeNode.appendChild(itemNode);
      }

      return typeNode;
    }

    /**
     * 屋根情報ノード
     */
    static roofInfoXML(): Element {
      const itemList:any[] = marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_ROOF_NO);
      // XML
      const typeNode = document.createElementNS(null, 'roof');
      typeNode.setAttribute('noki_de', String(marietta.webcad.WebCADGlobal.webcad2Dmanager.noki_de));
      typeNode.setAttribute('tsuma_de', String(marietta.webcad.WebCADGlobal.webcad2Dmanager.tsuma_de));
      for (let i = 0, len = itemList.length; i < len; i += 1) {
        const tarItem:marietta.webcad.item.Roof = itemList[i];
        const itemNode = document.createElementNS(null, 'item');
        itemNode.setAttribute('id', tarItem.itemInfo.id);
        itemNode.setAttribute('index', String(i + 1));
        itemNode.setAttribute('guid', String(tarItem.itemInfo.guid));
        itemNode.setAttribute('f', String(tarItem.itemInfo.floor));
        itemNode.setAttribute('type', String(tarItem.itemInfo.roof_type));
        if (tarItem.itemInfo.roof_type === 2) {
          itemNode.setAttribute('direction_type', String(tarItem.itemInfo.roof_direction));
        }
        // シェイプ
        const shapeNode = document.createElementNS(null, 'shape');
        const pointXML = tarItem.getPointXML();
        for (let j = 0, len2 = pointXML.length; j < len2; j += 1) {
          shapeNode.appendChild(pointXML[j]);
        }
        itemNode.appendChild(shapeNode);
        typeNode.appendChild(itemNode);
      }
      return typeNode;
    }
}
export default WebcadXMLExporter;
